module.exports = __webpack_public_path__ + "static/img/pear.cf0ffc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/pear.jpg
// module id = ZOOo
// module chunks = 1